import ModelTypeConstants from 'constants/ModelTypeConstants';
import {previewPlugin} from 'notebook/notes/previews/PreviewPluginFactory';

import AnnotationPreview from './AnnotationPreview';
import PrimerPairPreview from './PrimerPairPreview';
import SequenceAnalysisPreview from './SequenceAnalysisPreview';
import SequencePreview from './SequencePreview';
import SequencePrimerPreview from './SequencePrimerPreview';

const PREVIEWS_BY_TYPE = {
  [ModelTypeConstants.SEQUENCE]: SequencePreview,
  [ModelTypeConstants.ANNOTATION]: AnnotationPreview,
  [ModelTypeConstants.PRIMER_PAIR]: PrimerPairPreview,
  [ModelTypeConstants.SEQUENCE_ANALYSIS]: SequenceAnalysisPreview,
  [ModelTypeConstants.SEQUENCE_PRIMER]: SequencePrimerPreview,
};

export const SEQUENCE_PREVIEW_PLUGINS = Object.entries(PREVIEWS_BY_TYPE).map(([type, preview]) =>
  previewPlugin({type, preview})
);
